// extracted by mini-css-extract-plugin
export var logo = "_cf-2";
export var logoWrapper = "_cf-1";
export var strip = "_cf-0";